<template>
  <div>
    <div>
      <p class="text-zt-xl font-bold mb-8">
        {{ $t(`message.publishDocuments.${processType}.title`) }}
      </p>
      <div class="mb-6">
        <p class="text-zt-lg font-medium mb-6">
          {{ $t(`message.publishDocuments.${processType}.subtitle`) }}
        </p>
        <p
          class="text-zt-base w-11/12 text-zt-dark-400"
          v-html="$sanitize($t(`message.publishDocuments.${processType}.description`))"
        ></p>
      </div>
      <div class="inline-block w-11/12 relative h-32 mb-5">
        <div class="zt-input-main w-full flex">
          <div class="px-2 flex items-center justify-center">
            <zt-icon name="paperclip-2" class="text-zt-xl text-zt-dark-400" />
          </div>
          <div class="w-full relative flex items-center">
            <div
              class="w-full rounded border-zt-xs border-solid border-zt-dark-300 py-2"
            >
              <zt-chip
                @click:close="$emit('cancel-publish')"
                close-icon="close-rounded"
                square
                color="primary-100"
                class="ml-3 font-semibold"
                closable
              >
                {{ $t(`message.publishDocuments.${processType}.pdfSplited`) }}
              </zt-chip>
            </div>
          </div>
        </div>
        <div class="flex">
          <div class="flex flex-auto relative justify-start mt-2 ml-12">
            <span
              class="text-zt-success text-zt-base"
              v-html="
              $sanitize($t('message.publishDocuments.onlyPublish.success', {
                  quantity: processData.quantity_documents_generate,
                }))
              "
            ></span>
          </div>
        </div>
        <div
          class="preview-file flex text-base text-gray-600 mt-4 cursor-pointer font-semibold"
          @click="openModalPreview()"
        >
          <zt-icon
            class="text-lg no-underline"
            name="eye"
            :class="{ 'animate-spin': previewLoaderTxt.length > 0 }"
          />
          <p class="ml-3 text-preview">
            {{ $t(`message.publishDocuments.${processType}.preview`) }}
          </p>
        </div>
      </div>
    </div>
    <!-- MODAL PREVIEW DOCUMENTO  -->
    <zt-modal
      class="modal-preview"
      :active="modalPreviewActive"
      @close="modalPreviewActive = false"
      fullscreen
    >
      <template slot="modal-header">
        <div class="p-4 text-center font-bold">
          <h4>
            {{
              $t(
                `message.publishDocuments.${processType}.modalPreviewDocument.title`
              )
            }}
          </h4>
        </div>
      </template>     
      <file-visualizer
        :dataPreview="dataPreview"
        :isLoading="isLoading"
        @get-preview="
          (page) => {
            getDocumentPreview(page);
          }
        "
      />
      <template slot="modal-footer">
        <div
          class="flex justify-end items-center text-md p-4 fixed bottom-0 w-full bg-zt-dark-200"
        >
          <zt-button @click="modalPreviewActive = false">{{
            $t(
              `message.publishDocuments.${processType}.modalPreviewDocument.buttonClose`
            )
          }}</zt-button>
        </div>
      </template>
    </zt-modal>
  </div>
</template>

<script>
import PublishDocuments from "@/apiClient/PublishDocuments";
import fileVisualizer from "./fileVisualizer/fileVisualizer";

export default {
  inject: ["state", "mutations"],
  components: {
    fileVisualizer
  },
  props: {
    processData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      publishDocuments: new PublishDocuments(),
      modalPreviewActive: false,
      dataPreview: {},
      previewLoaderTxt: "",
      isLoading: false
    };
  },
  methods: {
    openModalPreview() {
      this.getDocumentPreview(1);
    },
    getDocumentPreview(page) {
      this.isLoading = true
      this.previewLoaderTxt = this.$t(
        `message.publishDocuments.${this.processType}.modalPreviewDocument.loaderTxt`
      );
      let params = {
        tag: this.processData.tag,
        page: page,
      };
      this.publishDocuments
        .getPreviewDocument(params)
        .then((response) => {
          this.dataPreview = response.data.data;
          this.previewLoaderTxt = "";
          this.modalPreviewActive = true;
          this.isLoading = false
        })
        .catch((error) => {
           this.isLoading = false
          let errorCode = error.response.data.codes[0].code;
          this.dataPreview = {
            total_pages: 0,
            width: 0,
            height: 0,
            page: "",
          };
          this.previewLoaderTxt = "";
          this.$emit("error-on-preview", errorCode);
        });
    },
  },
  computed: {
    processType() {
      return this.processData.type;
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.preview-file:hover {
  .text-preview {
    text-decoration: underline;
  }
}
::v-deep .modal-preview {
  .zt-modal-fullscreen-mode {
    z-index: 100 !important;
  }
}
</style>
